export default __webpack_public_path__ + "static/app-store-aa3eab6291a8dd8d30bff6ae793190b7.png";